import * as React from "react";
import {isOnMobile, getCardWidth} from "./imageUtils";

function Svg10OfHearts(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={getCardWidth()}
      viewBox="0 0 167.087 242.667"
      {...props}
      preserveAspectRatio={"xMidYMid meet"}
    >
      <defs>
        <linearGradient id="10_of_hearts_svg__a">
          <stop offset={0} />
          <stop offset={1} stopOpacity={0.649} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__b">
          <stop offset={0} stopColor="#fff" stopOpacity={0.435} />
          <stop offset={1} stopOpacity={0} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__c">
          <stop offset={0} stopColor="#fff" stopOpacity={0.489} />
          <stop offset={1} stopOpacity={0} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__d">
          <stop offset={0} stopColor="#fff" stopOpacity={0.237} />
          <stop offset={1} stopOpacity={0} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__e">
          <stop offset={0} stopColor="#df0000" />
          <stop offset={1} stopColor="#df0000" stopOpacity={0.672} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__f">
          <stop offset={0} stopColor="#fff" stopOpacity={0.313} />
          <stop offset={1} stopOpacity={0} />
        </linearGradient>
        <linearGradient id="10_of_hearts_svg__g">
          <stop offset={0} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={1} stopOpacity={0} />
        </linearGradient>
      </defs>
      <g stroke="#000">
        <path
          d="M166.837 235.548c0 3.777-3.087 6.869-6.871 6.869H7.11c-3.775 0-6.861-3.092-6.861-6.87V7.12C.25 3.343 3.336.25 7.11.25h152.856c3.784 0 6.87 3.093 6.87 6.87v228.428z"
          fill="#fff"
          strokeWidth={0.5}
        />
      </g>
      <text
        style={{
          lineHeight: "125%",
        }}
        x={-0.987}
        y={29.203}
        fontSize={32}
        fontWeight={400}
        letterSpacing={0}
        wordSpacing={0}
        fill="#df0000"
        fontFamily="Bitstream Vera Sans"
      >
        <tspan
          x={-0.987}
          y={29.203}

          fontFamily="Arial"
        >
          {"1"}
        </tspan>
      </text>
      <path
        d="M23.332 32.282c-5.43 0-6.154 5.449-6.154 5.449s-.725-5.449-6.155-5.449c-3.8 0-7.24 2.443-7.24 7.052 0 6.09 11.016 12.213 13.395 21.154 2.263-8.934 13.394-15.065 13.394-21.154 0-4.609-3.44-7.052-7.24-7.052zM144.001 209.246c5.43 0 6.155-5.448 6.155-5.448s.725 5.448 6.155 5.448c3.8 0 7.24-2.443 7.24-7.051 0-6.09-11.016-12.213-13.395-21.155-2.264 8.934-13.394 15.065-13.394 21.155 0 4.608 3.439 7.051 7.24 7.051zM64.728 6.596c-9.012 0-10.216 9.043-10.216 9.043S53.31 6.596 44.297 6.596c-6.309 0-12.017 4.055-12.017 11.704 0 10.107 18.284 20.27 22.232 35.112C58.27 38.583 76.744 28.407 76.744 18.3c0-7.65-5.708-11.704-12.016-11.704zM44.297 236.214c9.012 0 10.215-9.043 10.215-9.043s1.204 9.043 10.216 9.043c6.308 0 12.016-4.055 12.016-11.704 0-10.107-18.283-20.27-22.232-35.112-3.757 14.829-22.232 25.005-22.232 35.112 0 7.65 5.708 11.704 12.017 11.704zM64.728 71.83c-9.012 0-10.216 9.044-10.216 9.044S53.31 71.83 44.297 71.83c-6.309 0-12.017 4.054-12.017 11.704 0 10.107 18.284 20.27 22.232 35.112 3.758-14.83 22.232-25.005 22.232-35.112 0-7.65-5.708-11.704-12.016-11.704zM44.297 168.764c9.012 0 10.215-9.043 10.215-9.043s1.204 9.043 10.216 9.043c6.308 0 12.016-4.055 12.016-11.704 0-10.107-18.283-20.27-22.232-35.112-3.757 14.829-22.232 25.005-22.232 35.112 0 7.65 5.708 11.704 12.017 11.704zM122.207 7.195c-9.013 0-10.216 9.043-10.216 9.043s-1.203-9.043-10.216-9.043c-6.308 0-12.016 4.054-12.016 11.704 0 10.107 18.283 20.27 22.232 35.112 3.757-14.83 22.232-25.005 22.232-35.112 0-7.65-5.708-11.704-12.016-11.704zM101.775 236.813c9.013 0 10.216-9.043 10.216-9.043s1.203 9.043 10.216 9.043c6.308 0 12.016-4.055 12.016-11.704 0-10.107-18.284-20.27-22.232-35.112-3.757 14.829-22.232 25.005-22.232 35.112 0 7.65 5.708 11.704 12.016 11.704zM122.207 72.43c-9.013 0-10.216 9.043-10.216 9.043s-1.203-9.044-10.216-9.044c-6.308 0-12.016 4.055-12.016 11.704 0 10.107 18.283 20.271 22.232 35.112 3.757-14.828 22.232-25.005 22.232-35.112 0-7.649-5.708-11.704-12.016-11.704zM101.775 169.363c9.013 0 10.216-9.044 10.216-9.044s1.203 9.044 10.216 9.044c6.308 0 12.016-4.055 12.016-11.704 0-10.107-18.284-20.271-22.232-35.112-3.757 14.829-22.232 25.005-22.232 35.112 0 7.649 5.708 11.704 12.016 11.704zM93.429 39.297c-9.012 0-10.216 9.043-10.216 9.043s-1.203-9.043-10.215-9.043C66.689 39.297 60.98 43.35 60.98 51c0 10.107 18.284 20.27 22.232 35.112 3.758-14.83 22.232-25.005 22.232-35.112 0-7.65-5.708-11.704-12.016-11.704zM72.533 203.11c9.012 0 10.216-9.042 10.216-9.042s1.203 9.043 10.215 9.043c6.308 0 12.017-4.055 12.017-11.704 0-10.107-18.284-20.27-22.232-35.112-3.758 14.829-22.233 25.005-22.233 35.112 0 7.65 5.709 11.704 12.017 11.704z"
        fill="#df0000"
      />
      <text
        style={{
          lineHeight: "125%",
        }}
        x={12.287}
        y={28.96}
        fontSize={32}
        fontWeight={400}
        letterSpacing={0}
        wordSpacing={0}
        fill="#df0000"
        fontFamily="Bitstream Vera Sans"
      >
        <tspan
          x={12.287}
          y={28.96}

          fontFamily="Arial"
        >
          {"0"}
        </tspan>
      </text>
      <text
        style={{
          lineHeight: "125%",
        }}
        x={-167.598}
        y={-212.06}
        transform="scale(-1)"
        fontSize={32}
        fontWeight={400}
        letterSpacing={0}
        wordSpacing={0}
        fill="#df0000"
        fontFamily="Bitstream Vera Sans"
      >
        <tspan
          x={-167.598}
          y={-212.06}

          fontFamily="Arial"
        >
          {"1"}
        </tspan>
      </text>
      <text
        style={{
          lineHeight: "125%",
        }}
        x={-154.324}
        y={-212.302}
        transform="scale(-1)"
        fontSize={32}
        fontWeight={400}
        letterSpacing={0}
        wordSpacing={0}
        fill="#df0000"
        fontFamily="Bitstream Vera Sans"
      >
        <tspan
          x={-154.324}
          y={-212.302}

          fontFamily="Arial"
        >
          {"0"}
        </tspan>
      </text>
    </svg>
  );
}

export default Svg10OfHearts;
